<template lang="html">
    <report-section
        :id="id"
        title="Allocations By Industry"
    >
        <p>
            Water licences and approvals (allocations) in British Columbia are administered under the Water
            Sustainability Act. Existing, active water allocations in the watershed are summarized by water source,
            type, and term in the table below. On the following pages, each individual water allocation is listed with
            information on the specific water source and quantity, ordered by seniority.
        </p>

        <allocations-by-industry-table
            :industries="reportData.allocationsByIndustry"
            :sub-headers="subHeaders"
            :pdf="pdf"
        />

        <div class="purpose-use-code-groupings is-hidden-mobile">
            <h3 class="title">
                Purpose Use Code Groupings
            </h3>

            <h5 class="subtitle has-text-weight-bold">
                Agriculture
            </h5>
            <p>
                Crop Harvest, Protect & Compost, Crops: Crop Suppression, Crops: Flood Harvesting, Crops: Frost
                Protection, Greenhouse & Nursery, Greenhouse & Nursery: Greenhouse, Greenhouse & Nursery: Nursery,
                Irrigation: Local Provider, Irrigation: Private, Livestock & Animal, Livestock & Animal: Game Farm,
                Livestock & Animal: Kennel, Livestock & Animal: Stockwatering
            </p>

            <h5 class="subtitle has-text-weight-bold">
                Commercial
            </h5>
            <p>
                Bulk Shipment for Marine Transfer, Camps & Pub Facil, Camps & Pub Facil: Church/Com Hall, Camps & Pub
                Facil: Exhibition Grounds, Camps & Pub Facil: Institutions, Camps & Pub Facil: Non-Work Camps, Camps &
                Pub Facil: Public Facility, Camps & Pub Facil: Work Camps, Camps and Public Facilities, Comm.
                Enterprise, Comm. Enterprise: Amusement Park, Comm. Enterprise: Enterprise, Fish Hatchery, Fresh Water
                Bottling, Heat Exchanger, Ind'l & Comm., Ice & Snow Making, Ind'l Waste Mgmt: Effluent, Ind'l Waste
                Mgmt: Garbage Dump, Ind'l Waste Mgmt: Sewage Disposal, Industrial Waste Mgmt, Industrial (Well
                Drill/Transp Mgmt), Industrial-dewatering, Mineralized Water: Bottling & Dist, Mineralized Water: Comm.
                Bathing Pool, Mining: Hydraulic, Mining: Placer, Mining: Processing Ore, Mining: Washing Coal, Misc
                Ind'l, Misc Ind'l: Dewatering, Misc Ind'l: Fire Protection, Misc Ind'l: Overburden Disposal, Misc
                Ind'l: Sediment Control, N/A, Pond & Aquaculture, Processing & Mfg, Processing & Mfg: Fire Prevention,
                Processing & Mfg: Processing, Processing & Mfg: Wharves, Pulp Mill, Transport Mgmt: Dust Control,
                Transport Mgmt: Road Maint, Vehicle & Eqpt, Vehicle & Eqpt: Brake Cooling, Vehicle & Eqpt: Mine &
                Quarry, Vehicle & Eqpt: Truck & Eqpt Wash, Well Drilling/Transport Management
            </p>

            <h5 class="subtitle has-text-weight-bold">
                Domestic
            </h5>
            <p>
                Domestic, Incidental - Domestic
            </p>

            <h5 class="subtitle has-text-weight-bold">
                Municipal
            </h5>
            <p>
                Heat Exchanger, Residential, Land Improvement: General, Land Improvement: Ind'l for Rehab or Remed,
                Lwn, Fairway & Grdn, Lwn, Fairway & Grdn: Res L/G, Lwn, Fairway & Grdn: Watering, Swimming Pool,
                Waterworks (other than LP), Waterworks: Local Provider, Waterworks: Water Delivery, Waterworks: Water
                Sales
            </p>

            <h5 class="subtitle has-text-weight-bold">
                Oil & Gas
            </h5>
            <p>
                Industrial: Fire Suppression, Industrial: Pressure Testing, Industrial: Road Maintenance, Industrial:
                Work Camp, Oil & Gas Purpose: Hydraulic Fracturing, Oil & Gas Purpose: Oil Field Injection, Oil & Gas
                Purpose: Other, Oil & Gas Purpose: Well Drilling, Oil & Gas: Drilling, Oil & Gas: Hydraulic Fracturing
                (deep GW), Oil & Gas: Hydraulic Fracturing (non-deep GW), Oil & Gas: Oil field inject. (non-deep GW)
            </p>

            <h5 class="subtitle has-text-weight-bold">
                Other
            </h5>
            <p>
                Conservation: Construction Works, Conservation: Use of Water, Ice & Snow Making: Ice, Ice & Snow
                Making: Snow, Permit to Occupy Crown Land, River Improvement
            </p>

            <h5 class="subtitle has-text-weight-bold">
                Power
            </h5>
            <p>
                Cooling, Power: Commercial, Power: General, Power: Residential
            </p>

            <h5 class="subtitle has-text-weight-bold">
                Storage
            </h5>
            <p>
                Aquifer Storage: Non-Power, Conservation: Storage, Stream Storage: Non-Power, Stream Storage: Power
            </p>
        </div>
    </report-section>
</template>

<script>
import AllocationsByIndustryTable from '@foundryspatial/allocations-by-industry-table';
import sectionMixin from '@foundryspatial/report-section/mixin';

export default {
    name: 'AllocationsByIndustrySection',

    components: {
        AllocationsByIndustryTable,
    },

    mixins: [
        sectionMixin,
    ],

    props: {
        pdf: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: () => ({
        subHeaders: {
            long: 'Licence',
            longTooltip: '',
            short: 'STUA',
            shortTooltip: 'Short Term Use Approval',
        },
    }),
};
</script>

<style lang="scss">
#allocations-by-industry.report-section {
    .allocations-by-industry-table {
        margin-bottom: 1.25rem;
    }

    .purpose-use-code-groupings {
        h5 {
            margin-top: 1rem;
            margin-bottom: 0.25rem;
        }

        p {
            margin: 0.25rem 0;
        }
    }
}

.static-report #allocations-by-industry.report-section {
    p {
        margin-bottom: 1rem;
    }

    .allocations-by-industry-table {
        padding: 0;
        margin-bottom: 1rem;
    }

    .purpose-use-code-groupings {
        .title {
            font-size: 20px;
            line-height: 20px;
            margin-bottom: 1rem;
        }

        .subtitle {
            font-size: 10px;
            line-height: 10px;
            margin-top: 10px;
        }

        p {
            font-size: 10px;
            line-height: 12px;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
